module.exports = __webpack_public_path__ + "static/media/icon-transito.19a63a23.svg";